module.exports = __webpack_public_path__ + "static/media/TS-asset4.27df441c.svg";